import { callFetch } from './serviceHelpers';

export const getEventsForOrder = orderId =>
  callFetch(process.env.REACT_APP_OOPS_URL, 'GET', `api/v1/eventquery?verbose=true&orderId=${orderId}`);
